// hook
import useSettings from '../hooks/useSettings'

type LogoProps = {
    title?: string;
}

export default function MainLogo({ title, ...other }: LogoProps) {
    const { themeMode } = useSettings();
    const src = themeMode == 'light' ? '/static/logo/mainLight.png' : '/static/logo/mainDark.png';
    return (
        <img src={src} alt={title || 'logo'} {...other} />
    )
}